//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mainBannerHolder from "~/components/loading-placeholders/main-banner-holder";
import _ from "lodash";
import BrewRules from "~/components/content-elements/brew-rules.vue";
import { mapGetters } from "vuex";
import BannerType1 from "~/components/content-elements/banner-type-1";
import SocialShareBtns from "~/components/social-share-btns";
export default {
  data() {
    return {};
  },
  async asyncData({ store }) {
    await store.dispatch("all-about-tea/getPerfectCupTea");
    const pageData = store.state["all-about-tea"].perfectCupTea;
    return { pageData };
  },
  head() {
    return {
      title: this.pageData.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.pageData.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.pageData.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.pageData.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.pageData.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.pageData.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.pageData.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.pageData.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.pageData.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.pageData.seo.prevent_indexing,
        },
      ],
    };
  },

  components: {
    BrewRules,
    BannerType1,
    SocialShareBtns,
    mainBannerHolder,
  },
  methods: {},
  computed: {
    ...mapGetters({
      ruleSet: "all-about-tea/brewRules",
    }),
  },
};
